module.exports = __webpack_public_path__ + "assets/images/e2d2b3ab9ced9fc6608b44a95a0d1dd8.png";